const doc = [({"en":({"adminConstantHotelDisplayCalendarType":({"displayed":"Display", "hidden":"Not displayed", "hideButton":"Hide Show Price button"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;